"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = exports.BreadcrumbItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var is_child_of_type_1 = require("../_util/is-child-of-type");
var config_context_1 = require("../_util/config-context");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
exports.BreadcrumbItem = react_1.forwardRef(function BreadcrumbItem(_a, ref) {
    var current = _a.current, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["current", "children", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    if (typeof children === "string") {
        // eslint-disable-next-line no-param-reassign
        children = react_1.default.createElement("span", null, children);
    }
    return (react_1.default.createElement("li", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-breadcrumb__item", className) }, props), react_1.default.isValidElement(children)
        ? react_1.default.cloneElement(children, {
            className: classnames_1.default(children.props.className, classPrefix + "-breadcrumb__item-title", {
                "is-current": current,
            }),
        })
        : children));
});
exports.BreadcrumbItem.displayName = "BreadcrumbItem";
exports.Breadcrumb = forward_ref_with_statics_1.forwardRefWithStatics(function Breadcrumb(_a, ref) {
    var _b;
    var large = _a.large, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["large", "children", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("ol", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-breadcrumb", className, (_b = {},
            _b[classPrefix + "-breadcrumb--fz-large"] = large,
            _b)) }, props), react_1.default.Children.map(children, function (child, index) {
        if (is_child_of_type_1.isChildOfType(child, exports.BreadcrumbItem) &&
            index === react_1.default.Children.count(children) - 1) {
            return react_1.default.cloneElement(child, {
                current: true,
            });
        }
        return child;
    })));
}, {
    Item: exports.BreadcrumbItem,
});
exports.Breadcrumb.displayName = "Breadcrumb";
//# sourceMappingURL=Breadcrumb.js.map